/* eslint-disable no-sequences */
import React, { useState, useEffect } from "react";
import "./MobileProductlist.css";
import {
  FaTrash,
  FaTag,
  FaPercent,
  FaBox,
  FaBuilding,
  FaCoins,
  FaCalendarAlt,
  FaPlus,
} from "react-icons/fa";
import axios from "axios";
import { Api } from "../../BackendApi/api";
import img from "../MobileProductlist/MobileProductHeader/mobilelogo.png";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import Spinner from "../../Component/Spinner/Spinner";
import { formatIndianDate } from "../../Component/IndFormatDate/formatIndianDate";
import MobileProductHeader from "./MobileProductHeader/MobileProductHeader";
import MobileDeletePopup from "../../Component/MobileDeletePopup/MobileDeletePopup";
import MobileConfirmPopup from "../../Component/MobileConfirmPopup/MobileConfirmPopup";
import MobileEditProductOverlay from "./MobileEditProductOverlay/MobileEditProductOverlay";
import MobileProductOverlay from "./MobileProductOverlay";

const columnToApiMap = {
  productName: "ProductName",
  description: "Description",
  categoryName: "CategoryName",
  mrp: "ProductMRP",
  sellingPrice: "ProductSellingPrice",
  coins: "AllotCoins",
  companyName: "CompName",
  status: "Status",
  stock: "CurrentStock",
  createdBy: "CreatedByAdminName",
  lastUpdated: "LastUpdate",
};

const MobileProductlist = () => {
  const [globalSearch, setGlobalSearch] = useState("");
  const [columnSearch, setColumnSearch] = useState({
    Sr: "",
    productName: "",
    description: "",
    categoryName: "",
    image: "",
    mrp: "",
    sellingPrice: "",
    companyName: "",
    coins: "",
    status: "Active",
    stock: "",
    createdBy: "",
    lastUpdated: "",
  });

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sortState, setSortState] = useState({
    column: "lastUpdated",
    order: "desc",
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);

  const [popup, setPopup] = useState({ show: false, message: "", type: "success" });

  const navigate = useNavigate();
  const limit = 10;

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };
  const handleEditClick = (product) => {
    setSelectedProduct(product);
    setShowEditModal(true);
  };

  const confirmDelete = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/");
        return;
      }

      const productToUpdate = data.find(
        (row) => row.originalProduct._id === selectedId
      )?.originalProduct;

      if (!productToUpdate) {
        setPopup({
          show: true,
          message: "Product not found",
          type: "error",
        });
        return;
      }

      const res = await axios.post(
        Api.editProducts,
        {
          _id: productToUpdate._id,
          CategoryId: productToUpdate.CategoryId,
          ProductName: productToUpdate.ProductName,
          Description: productToUpdate.Description,
          ProductMRP: productToUpdate.ProductMRP,
          ProductSellingPrice: productToUpdate.ProductSellingPrice,
          AllotCoins: productToUpdate.AllotCoins,
          CurrentStock: productToUpdate.CurrentStock,
          Status: "Deactive",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === 1) {
        setPopup({
          show: true,
          message: "Product deactivated successfully!",
          type: "success",
        });
        setShowDeleteModal(false);
        setSelectedId(null);
        setData([]);
        setPage(1);
        setHasMore(true);
        fetchProducts(1);
      } else {
        setPopup({
          show: true,
          message: "Failed to deactivate product. Please try again.",
          type: "error",
        });
      }
    } catch (err) {
      console.error("Error deactivating product:", err);
      setPopup({
        show: true,
        message: "Something went wrong",
        type: "error",
      });
    } finally {
      setShowDeleteModal(false);
      setSelectedId(null);
    }
  };

  const fetchProducts = async (pageNum = 1) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/");
        return;
      }

      const startfrom = (pageNum - 1) * limit;
      const apiSortColumn = columnToApiMap[sortState.column] || "LastUpdate";
      const apiSortOrder = sortState.order === "asc" ? 1 : -1;

      const res = await axios.post(
        Api.getProducts,
        {
          startfrom,
          limit,
          Status:
            columnSearch.status === "Active"
              ? "true"
              : columnSearch.status === "Deactive"
                ? "false"
                : "",
          CategoryId: "",
          productName: columnSearch.productName || "",
          description: columnSearch.description || "",
          categoryName: columnSearch.categoryName || "",
          mrp: columnSearch.mrp || "",
          sellingPrice: columnSearch.sellingPrice || "",
          coins: columnSearch.coins || "",
          searchstring: globalSearch || "",
          SortColumn: apiSortColumn,
          SortOrder: apiSortOrder,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === 1 && Array.isArray(res.data.data)) {
        const products = res.data.data.map((item, index) => ({
          Sr: startfrom + index + 1,
          productName: item.ProductName || "",
          description: item.Description || "",
          categoryName: item.CategoryName || "N/A",
          image:
            item.ProductImages && item.ProductImages.length > 0
              ? `${Api.baseurl}/${item.ProductImages[0]}`
              : img,
          mrp: item.ProductMRP || 0,
          sellingPrice: item.ProductSellingPrice || 0,
          companyName: item.CompName || "N/A",
          coins: item.AllotCoins != null ? item.AllotCoins : 0,
          status: item.Status === "true",
          stock: item.CurrentStock != null ? item.CurrentStock : 0,
          createdBy: item.CreatedByAdminName || "Admin",
          lastUpdated: item.LastUpdate ? formatIndianDate(item.LastUpdate) : "-",
          originalProduct: item,
        }));

        setData((prev) => (pageNum === 1 ? products : [...prev, ...products]));
        if (products.length < limit) setHasMore(false);
      } else {
        setHasMore(false);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      setPopup({
        show: true,
        message: err.response?.data?.message || "Failed to fetch products.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setData([]);
    setPage(1);
    setHasMore(true);
    const handler = setTimeout(() => {
      fetchProducts(1);
    }, 300);
    return () => clearTimeout(handler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalSearch, columnSearch, sortState]);

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchProducts(nextPage);
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
  };

 return (
  <>
    <div
      className={`mobile-product-main-wrapper ${
        showEditModal || showAddModal ? "blurred" : ""
      }`}
    >
      <div className="mobile-product-table-container">
        <MobileProductHeader
          search={globalSearch}
          setSearch={setGlobalSearch}
          columnSearch={columnSearch}
          setColumnSearch={setColumnSearch}
          onRefresh={() => {
            setData([]);
            setPage(1);
            setHasMore(true);
            fetchProducts(1);
          }}
        />

        <div id="mobilescrollableDiv">
          {loading && page === 1 ? (
            <Spinner />
          ) : data.length > 0 ? (
            <InfiniteScroll
              dataLength={data.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<Spinner />}
              endMessage={<div className="mobile-no-data">No more products</div>}
              scrollableTarget="mobilescrollableDiv"
              style={{ overflow: "visible" }}
            >
              {data.map((row, index) => (
                <div
                  className={`mobile-product-card ${
                    row.status ? "active" : "deactive"
                  }`}
                  key={index}
                  onClick={() => handleEditClick(row.originalProduct)}
                >
                  <div className="mobile-product-card-top">
                    <img
                      src={row.image}
                      alt={row.productName}
                      className="mobile-product-image"
                    />
                    <div className="mobile-product-info">
                      <h4 className="mobile-product-name">
                        {row.productName}
                      </h4>
                      <p className="mobile-product-company">
                        <FaBuilding className="mobile-product-icon" />{" "}
                        {row.companyName}
                      </p>
                    </div>
                    <div className="mobile-coins-badge">
                      <FaCoins className="mobile-coin-icon" />
                      <span>{row.coins}</span>
                    </div>
                  </div>

                  <div className="mobile-product-card-body">
                    <p>
                      <FaTag className="mobile-product-icon" />{" "}
                      <strong>MRP:</strong> ₹{row.mrp}
                    </p>
                    <p>
                      <FaPercent className="mobile-product-icon" />{" "}
                      <strong>Selling:</strong> ₹{row.sellingPrice}
                    </p>
                    <p>
                      <FaBox className="mobile-product-icon" />{" "}
                      <strong>Stock:</strong> {row.stock}
                    </p>
                  </div>

                  <div className="mobile-product-card-bottom">
                    <p>
                      <FaCalendarAlt className="mobile-product-icon" />{" "}
                      {row.lastUpdated}
                    </p>
                    <div className="mobile-product-actions">
                      <button
                        className="mobile-product-delete"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(row.originalProduct._id);
                        }}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </InfiniteScroll>
          ) : (
            <div className="mobile-no-data">
              {loading ? "Loading products..." : "No products found"}
            </div>
          )}
        </div>
      </div>

      {!showAddModal && (
        <button
          className="floating-add-btn"
          onClick={() => setShowAddModal(true)}
        >
          <FaPlus />
        </button>
      )}
    </div>

    {showEditModal && selectedProduct && (
      <MobileEditProductOverlay
        product={selectedProduct}
        onClose={() => setShowEditModal(false)}
        onSave={() => {
          setShowEditModal(false);
          setData([]);
          setPage(1);
          setHasMore(true);
          fetchProducts(1);
        }}
      />
    )}

    {showAddModal && (
      <MobileProductOverlay
        onClose={() => setShowAddModal(false)}
        onSave={() => {
          setShowAddModal(false);
          setData([]);
          setPage(1);
          setHasMore(true);
          fetchProducts(1);
        }}
      />
    )}

    <MobileDeletePopup
      show={showDeleteModal}
      onClose={() => setShowDeleteModal(false)}
      onConfirm={confirmDelete}
    />
    <MobileConfirmPopup
      show={popup.show}
      message={popup.message}
      type={popup.type}
      onClose={handlePopupClose}
    />
  </>
);

};

export default MobileProductlist;
